import { makeAutoObservable } from 'mobx'
import CheckableMap from 'src/models/CheckableMap'

import { MakeProblem } from '..'

export class FavoriteProblemColl {
  constructor(private worksheetMap: CheckableMap<MakeProblem['id'], MakeProblem>) {
    makeAutoObservable(this)
  }

  get toArr() {
    return [...this.worksheetMap.values()]
  }

  get entries() {
    return this.worksheetMap.entries()
  }

  values() {
    return this.worksheetMap.values()
  }

  set(k, v) {
    return this.worksheetMap.set(k, v)
  }

  has(k) {
    return this.worksheetMap.has(k)
  }

  delete(id) {
    return this.worksheetMap.delete(id)
  }

  checkSize() {
    return this.worksheetMap.checkSize
  }

  toCheckedValues() {
    return this.worksheetMap.toCheckedValues
  }

  toCheckedSize() {
    return this.worksheetMap.toCheckedValues.length
  }

  get(k) {
    return this.worksheetMap.get(k)
  }

  setCheck(v: MakeProblem['id']) {
    this.worksheetMap.setCheck(v)
  }
  clearAllCheck() {
    this.worksheetMap.clearAllCheck()
  }
  isChecked(v: MakeProblem['id']) {
    return this.worksheetMap.isChecked(v)
  }
  get isPartChecked() {
    return this.worksheetMap.isPartChecked
  }
  toggleCheck(v: MakeProblem['id']) {
    this.worksheetMap.toggleCheck(v)
  }

  adds(worksheetColl) {
    this.worksheetMap.adds(worksheetColl.worksheetMap.entries())
  }
}
